<script setup lang="ts">
import type { ConvinientSelectProps } from '.';

import Convinient from './Convinient.vue';

defineProps<ConvinientSelectProps>();
defineEmits<{
	(event: 'update:bedrooms', value: ConvinientSelectProps['bedrooms']): void;
	(event: 'update:suites', value: ConvinientSelectProps['suites']): void;
	(event: 'update:bathrooms', value: ConvinientSelectProps['bathrooms']): void;
	(
		event: 'update:parkingSpots',
		value: ConvinientSelectProps['parkingSpots']
	): void;
}>();

const bedrooms = defineModel<ConvinientSelectProps['bedrooms']>('bedrooms', {
	required: true,
	default: 0
});
const bathrooms = defineModel<ConvinientSelectProps['bathrooms']>('bathrooms', {
	required: true,
	default: 0
});
const suites = defineModel<ConvinientSelectProps['suites']>('suites', {
	required: true,
	default: 0
});
const parkingSpots = defineModel<ConvinientSelectProps['parkingSpots']>(
	'parkingSpots',
	{
		required: true,
		default: 0
	}
);
</script>

<template>
	<div class="w-full space-y-5">
		<p
			class="flex w-full items-center font-matter-sq text-lg leading-[150%] tracking-[-0.36px] text-primary"
		>
			Cômodos
		</p>
		<Convinient v-model="bedrooms" convinient="bedrooms" />
		<Convinient v-model="suites" convinient="suites" />
		<Convinient v-model="bathrooms" convinient="bathrooms" />
		<Convinient v-model="parkingSpots" convinient="parkingSpots" />
	</div>
</template>
